import React, {Component} from 'react'
import FormatMessage from "../messages/FormatMessage";
import EQLeftNavigation from './tags/EQLeftNavigationTree'
import {handleFormSubmit, submitFormData} from "../assets-static/scripts/Validation";
import {loadApplicationData, pageDetails, saveApplicationData} from "../actions/ApplicationAction";
import {isFirstPage} from "../assets-static/scripts/utils";
import {injectIntl} from "react-intl";
import dot from "dot-object";

                                    import YesNo_NoDefault from "./tags/YesNo_NoDefault";
                                        import {EQ_Button_Navigation} from "./tags/EQ_Button_Navigation";
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import EQHeader from './EQHeader';
import EQFooter from './EQFooter';
import EQMobileMenu from "./EQMobileMenu";

class EQ_7_1 extends Component {
constructor(props) {
super(props);
this.state = {
isValid: true,
mobileMenu: false
}
this.handleMobileMenu = this.handleMobileMenu.bind(this);
this.ShowContentRBReq1 = this.ShowContentRBReq1.bind(this);
}

componentDidMount() {
handleFormSubmit(this.props)
const script = document.createElement("script");
script.src = "/mxcitizenship/scripts/utils.js?v=3.0";
script.async = true;
document.body.appendChild(script);
}

handleNext = (element) => {
const isValid = submitFormData()
if (isValid) {
element.className = element.className + " LoadingButton LoadingButton-loading";
pageDetails("mxcitizenship", this.props.application.applicationData, "NEXT", "EQ-7.1", "PAGE_STATUS_COMPLETE").then((nextPage) => {
element.className = element.className.replace(" LoadingButton LoadingButton-loading", "")
if (nextPage != "") {
loadApplicationData("mxcitizenship").then((data) => {
this.props.dispatch(data)
nextPage.includes("http") ? window.location.href = nextPage :
nextPage.includes("redirect") ? window.location.href = nextPage.split("redirect=")[1] :
this.props.history.push(nextPage);
});
}
});
} else {
this.setState({
isValid: isValid
})
}
}

handlePrevious = () => {
pageDetails("mxcitizenship", this.props.application.applicationData, "PREV", "EQ-7.1", "PAGE_STATUS_NOT_VISITED").then((prevPage) => {
this.props.history.push(prevPage);
});
}

hasBack = () => {
                                                                                                                                                                                                                                             return !isFirstPage("EQ-7.1", ["EQ-1.1","EQ-3.2","EQ-4.1","EQ-5.1","EQ-6.1","EQ-7.1","EQ-7.2","EQ-7.3","EQ-1.2","EQ-1.3","EQ-1.4","EQ-8.1","EQ-8.3","EQ-8.2","EQ-2.1","EQ-2.2","EQ-2.3","EQ-3.1"]);
}

handleMobileMenu(value) {
this.setState({
mobileMenu: value
})
}

ShowContentRBReq1(var1, var2) {
if (document.getElementById(var2).checked) {
document.getElementById(var1).style.display = "block";
} else {
document.getElementById(var1).style.display = "none";
}
}

render() {
return (
<div className="Site">
    <EQHeader handleMobileMenu={(value) => this.handleMobileMenu(value)}/>
    <div className="SiteContent">
        <div className="SiteContent-container">
            <div className="App">
                <div className="EqSubHeader">
                    <div className="EqSubHeader-form">
                        <FormatMessage id="form.title"/>	
                    </div>
                    <div className="EqSubHeader-label">
                        <FormatMessage id="eq.pageheader"/>
                    </div>
                </div>
                <div className="FixedLayout App-layout">
                    <div className="FixedLayoutAside App-aside">
                        <EQLeftNavigation hasSidebar="true" closedSectionKey="eq.lnt.section.closed"/>
                    </div>
                    <div className="FixedLayoutMain App-main">
                        <div className="Page">
                            <form id="application_form">
                                <div className="EqQuestionPage">
                                    {!this.state.isValid &&
                                    <div className="PageError">
                                        <div className="PageError-label">
                                            <FormatMessage id="control.complete.highlightedfields"/>
                                        </div>
                                    </div>
                                    }
                                    <div className="Questions EqQuestionPage-questions">
                                                                                                                                                                            <div className="QuestionSectionGroup" id="section-7.1.1">
                                                                                                                                                                <YesNo_NoDefault beanName="applicationData" property="quiz.adoptedByOrDescendantOfMexican" personalisation="true" 
questionKey="eq7.1.pagetext" 
yesLabel="control.radiobutton.yes" 
noLabel="control.radiobutton.no" 
required="true" 
errorKey="error.control.pleaseselect" 
 application={this.props.application} dispatchApplicationData={this.dispatchApplicationData.bind(this)} />
                                                                                                                                                        </div>
                                                                                                                        </div>
                                    <EQ_Button_Navigation hasBack={this.hasBack()}
                                                          navNext={this.handleNext}
                                                          navPrevious={this.handlePrevious}>
                                    </EQ_Button_Navigation>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <EQFooter />
</div>)
}
dispatchApplicationData(applicationData) {
this.setState({
isValid: true
})
this.props.dispatch(saveApplicationData(applicationData))
}
}

const mapStateToProps = state => {
return {
application: state.application
}
}

export default connect(mapStateToProps)(injectIntl(withRouter(EQ_7_1)))
